// extracted by mini-css-extract-plugin
export default {"List":"EjFwbfUtAqjtowN6S8lJ","Item":"KA14sZ0r0qb8_TRxNj6t"};